import { InsuranceCompany } from "../../interfaces/screens/billing";

let mockInsurers: InsuranceCompany[] = [
  {
    id: "nssf_main",
    name: "National Social Security Fund (NSSF)",
    contact_person: "NSSF Claims Department",
    phone_number: "01-612-000",
    email: "claims@nssf.gov.lb",
    address: "NSSF Building, Corniche El Nahr, Beirut",
    notes: "Government social security fund for Lebanese workers",
    insurer_type: "nssf",
    nssf_branch_code: "BEIRUT_01",
    claim_submission_address: "NSSF Claims Department, Beirut",
    claim_submission_phone: "01-612-000",
    claim_submission_email: "claims@nssf.gov.lb",
    processing_time_days: 60,
    requires_paper_submission: true,
    accepts_electronic_submission: false,
    coverage_percentages: {
      consultation: 80,
      lab_tests: 70,
      radiology: 60,
      procedures: 50,
      medications: 40,
    },
  },
  {
    id: "moph_main",
    name: "Ministry of Public Health (MOPH)",
    contact_person: "MOPH Claims Department",
    phone_number: "01-614-000",
    email: "claims@moph.gov.lb",
    address: "Ministry of Public Health, Beirut",
    notes: "Government health coverage for vulnerable populations",
    insurer_type: "moph",
    moph_contract_number: "MOPH-2024-001",
    claim_submission_address: "MOPH Claims Department, Beirut",
    claim_submission_phone: "01-614-000",
    claim_submission_email: "claims@moph.gov.lb",
    processing_time_days: 90,
    requires_paper_submission: true,
    accepts_electronic_submission: false,
    coverage_percentages: {
      consultation: 100,
      lab_tests: 100,
      radiology: 100,
      procedures: 100,
      medications: 100,
    },
  },
  {
    id: "allianz_sna",
    name: "Allianz SNA",
    contact_person: "John Doe",
    phone_number: "01-234-567",
    email: "claims@allianz-sna.com",
    address: "Allianz SNA Building, Beirut, Lebanon",
    notes: "Private health insurance provider",
    insurer_type: "private",
    claim_submission_address: "Allianz SNA Claims Department, Beirut",
    claim_submission_phone: "01-234-567",
    claim_submission_email: "claims@allianz-sna.com",
    processing_time_days: 15,
    requires_paper_submission: false,
    accepts_electronic_submission: true,
    fee_schedule_url: "https://allianz-sna.com/fee-schedule",
    coverage_percentages: {
      consultation: 90,
      lab_tests: 85,
      radiology: 80,
      procedures: 75,
      medications: 70,
    },
  },
  {
    id: "bankers_assurance",
    name: "Bankers Assurance",
    contact_person: "Jane Smith",
    phone_number: "01-345-678",
    email: "info@bankers-assurance.com",
    address: "Bankers Assurance Building, Sin El Fil, Lebanon",
    notes: "Private health insurance provider",
    insurer_type: "private",
    claim_submission_address: "Bankers Assurance Claims Department, Sin El Fil",
    claim_submission_phone: "01-345-678",
    claim_submission_email: "claims@bankers-assurance.com",
    processing_time_days: 20,
    requires_paper_submission: false,
    accepts_electronic_submission: true,
    fee_schedule_url: "https://bankers-assurance.com/fee-schedule",
    coverage_percentages: {
      consultation: 85,
      lab_tests: 80,
      radiology: 75,
      procedures: 70,
      medications: 65,
    },
  },
  {
    id: "medgulf",
    name: "Medgulf",
    contact_person: "Sam T.",
    phone_number: "01-456-789",
    email: "contact@medgulf.com.lb",
    address: "Medgulf Building, Beirut, Lebanon",
    notes: "Private health insurance provider",
    insurer_type: "private",
    claim_submission_address: "Medgulf Claims Department, Beirut",
    claim_submission_phone: "01-456-789",
    claim_submission_email: "claims@medgulf.com.lb",
    processing_time_days: 18,
    requires_paper_submission: false,
    accepts_electronic_submission: true,
    fee_schedule_url: "https://medgulf.com.lb/fee-schedule",
    coverage_percentages: {
      consultation: 88,
      lab_tests: 82,
      radiology: 78,
      procedures: 72,
      medications: 68,
    },
  },
  {
    id: "cooperative_insurance",
    name: "Cooperative Insurance",
    contact_person: "Ahmed Hassan",
    phone_number: "01-567-890",
    email: "claims@coop-insurance.lb",
    address: "Cooperative Insurance Building, Beirut",
    notes: "Cooperative health insurance provider",
    insurer_type: "cooperative",
    claim_submission_address: "Cooperative Insurance Claims Department, Beirut",
    claim_submission_phone: "01-567-890",
    claim_submission_email: "claims@coop-insurance.lb",
    processing_time_days: 25,
    requires_paper_submission: true,
    accepts_electronic_submission: false,
    coverage_percentages: {
      consultation: 75,
      lab_tests: 70,
      radiology: 65,
      procedures: 60,
      medications: 55,
    },
  },
];

const getInsurers = (): Promise<InsuranceCompany[]> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockInsurers);
    }, 500);
  });
};

const addInsurer = (
  insurer: Omit<InsuranceCompany, "id">,
): Promise<InsuranceCompany> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const newInsurer = { ...insurer, id: String(mockInsurers.length + 1) };
      mockInsurers = [...mockInsurers, newInsurer];
      resolve(newInsurer);
    }, 500);
  });
};

const updateInsurer = (
  insurer: InsuranceCompany,
): Promise<InsuranceCompany> => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const index = mockInsurers.findIndex((i) => i.id === insurer.id);
      if (index !== -1) {
        mockInsurers = mockInsurers.map((i) =>
          i.id === insurer.id ? insurer : i,
        );
        resolve(insurer);
      } else {
        reject(new Error("Insurer not found"));
      }
    }, 500);
  });
};

const deleteInsurer = (insurerId: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const index = mockInsurers.findIndex((i) => i.id === insurerId);
      if (index !== -1) {
        mockInsurers = mockInsurers.filter((i) => i.id !== insurerId);
        resolve();
      } else {
        reject(new Error("Insurer not found"));
      }
    }, 500);
  });
};

export const insurers = {
  getInsurers,
  addInsurer,
  updateInsurer,
  deleteInsurer,
};
